export enum VehicleTypeEnum {
  Car = 1,
  Truck = 2,
  Motorcycle = 3,
};
